import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { NgxOtpInputConfig, NgxOtpInputComponent } from 'ngx-otp-input';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { AccountSettingsService } from '../account-setting.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-account-verify',
  templateUrl: './delete-account-verify.component.html',
  styleUrls: ['./delete-account-verify.component.scss'],
})
export class DeleteAccountVerifyComponent implements OnInit {
  @ViewChild('ngxotp') ngxOtp: NgxOtpInputComponent | undefined;
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 6,
    autofocus: true,
    autoblur: true,
  };

  phoneLastDigits: string = '';
  otpValue: string = '';
  medium: 'phone' | 'email' = 'phone';
  CONSTANTS = CONSTANTS;
  private readonly otpValidationErrorKeys: string[] = [
    'VERIFICATION_CODE_IS_EXPIRE',
    'VERIFICATION_CODE_IS_INCORRECT',
    'NUMBER_OF_RETRIES_EXCEEDED',
  ];

  constructor(
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    const user = this.stateManagementService.getUser();
    if (user?.phoneNumber) {
      this.phoneLastDigits = user.phoneNumber.slice(-2);
    }
    this.resendCode();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  // Unified resend function
  resendCode(): void {
    this.accountSettingService
      .generateDeleteCode('delete', this.medium)
      .subscribe({
        next: (res: any) => {
          if (res?.generateCode?.success) {
            const message =
              this.medium === 'phone'
                ? 'CODE_HAS_BEEN_SENT_TO_YOUR_PHONE'
                : 'CODE_HAS_BEEN_SENT_TO_YOUR_EMAIL';
            this.notificationService.showSuccess(
              this.translate.instant(message)
            );
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
  }

  // Toggle medium and resend code immediately
  toggleAndResend(): void {
    this.toggleMedium(); // Switch medium
    this.resendCode(); // Resend code to the new medium
  }

  toggleMedium(): void {
    this.medium = this.medium === 'phone' ? 'email' : 'phone';
  }

  handleFillEvent(value: string): void {
    this.otpValue = value;
  }

  validateOtp(): void {
    if (this.otpValue?.length === 6) {
      this.accountSettingService
        .deactivateMyAccount(this.otpValue, this.medium)
        .subscribe({
          next: (res: any) => {
            if (res?.deactivateMyAccount) {
              this.stepperChange.emit((this.stepper = 9));
            }
          },
          error: (err: Error) => {
            if (err?.message === this.translate.instant('NUMBER_OF_RETRIES_EXCEEDED')) {
              this.notificationService.showError(err?.message);
              this.dialogRef?.close();
              return;
            }

            const isOtpValidationError = this.otpValidationErrorKeys.some(
              (key: string) => err?.message === this.translate.instant(key)
            );

            if (isOtpValidationError) {
              this.notificationService.showError(err?.message);
              this.ngxOtp?.clear();
              this.otpValue = '';
              return;
            }

            // Backend can deactivate the account successfully and then return a generic
            // GraphQL error because the account is no longer active. Continue success flow.
            this.stepperChange.emit((this.stepper = 9));
          },
        });
    }
  }
}
